


















import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Toast } from "vant";

import stepBar from "@/components/searchMember/stepBar.vue";

const searchMemberModule = namespace("searchMember");

@Component({
  components: {
    stepBar
  }
})
export default class SearchMember extends Vue {
  active: number = 1;
  memberKeyword: string = "";
  searchCardNo: string = "";

  mounted() {
    (this as any).$wechartfunc();
    this.$store.commit("coupon/setcouponSearchStep", 1);
  }

  onSearchMobile() {
    // if (!this.memberKeyword||!this.searchCardNo) {
    //   return this.$toast("请输入会员/手机号");
    // }
    console.log(console.log(this.$global));
    if (!this.searchCardNo) {
      if (!this.memberKeyword) {
        return Toast("请输入会员/手机号");
      }
    }
    this.$store
      .dispatch("searchMember/memberDetail", {
        searchText: this.searchCardNo ? this.searchCardNo : this.memberKeyword,
        searchType: 1
      })
      .then(({ success, error }) => {
        if (success) {
          let memberKeyword = this.memberKeyword;
          this.navigateTo(`/couponVerification/memberDetail`, {
            memberKeyword
          });
        } else {
          this.onSearchCardNo();
        }
      });
  }
  onSearchCardNo() {
    this.$store
      .dispatch("searchMember/memberDetail", {
        searchText: this.searchCardNo ? this.searchCardNo : this.memberKeyword,
        searchType: 3
      })
      .then(({ success, error }) => {
        if (success) {
          let memberKeyword = this.memberKeyword;
          this.navigateTo(`/couponVerification/memberDetail`, {
            memberKeyword
          });
        } else {
          return Toast(error.msg);
        }
      });
  }
  navigateTo(path: string, query: object = {}) {
    if (!path) {
      return Toast("无此路径");
    }
    this.$router.push({
      path,
      query: { ...query }
    });
  }
  async scancode() {
    // const wx: any = (window as any).wx;
    // const _this: any = this;
    // wx.scanQRCode({
    //   needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
    //   scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
    //   success: function(res: any) {
    //     this.memberKeyword = res.resultStr;
    //     if (res.resultStr) {
    //       this.onSearchCardNo();
    //     } else {
    //       return Toast("没有获取到会员码");
    //     }
    //   }
    // });
    const scanQRCode: any = await (this as any).$wechartfunc("scanQRCode");

    if (scanQRCode) {
      this.searchCardNo = scanQRCode;
      this.onSearchMobile();
    } else {
      return Toast("无此会员");
    }
  }
}
